import {
  FETCH_ALL_ORDER,
  FETCH_ALL_ORDER_FAILED,
  FETCH_ALL_ORDER_SUCCEED,
  FETCH_OPEN_ORDER,
  FETCH_OPEN_ORDER_FAILED,
  FETCH_OPEN_ORDER_SUCCEED,
  FETCH_ORDER,
  FETCH_ORDER_FAILED,
  FETCH_ORDER_SUCCEED,
  FETCH_ORDER_PAGINATE,
  FETCH_ORDER_PAGINATE_SUCCEED,
  FETCH_ORDER_PAGINATE_FAILED,
  CANCEL_ORDER,
  CANCEL_ORDER_SUCCEED,
  CANCEL_ORDER_FAILED,
  CANCEL_ALL_ORDER,
  CANCEL_ALL_ORDER_SUCCEED,
  CANCEL_ALL_ORDER_FAILED,
  ADD_ORDER,
  ADD_ORDER_SUCCEED,
  ADD_ORDER_FAILED,
  FETCH_ORDERS,
  FETCH_ORDERS_SUCCEED,
  FETCH_ORDERS_FAILED,
  FETCH_OPEN_ORDERS_PAGINATE,
  FETCH_OPEN_ORDERS_PAGINATE_SUCCEED,
  FETCH_OPEN_ORDERS_PAGINATE_FAILED,
} from './action_types';
import consts from '../../../consts';

export default {
  fetchOpenOrderAction: (data) => ({
    type: FETCH_OPEN_ORDER,
    params: {
      data,
    },
  }),
  fetchOpenOrderActionSucceed: (data, totalCount) => ({
    type: FETCH_OPEN_ORDER_SUCCEED,
    data,
    total_count: totalCount,
  }),
  fetchOpenOrderActionFailed: (err) => ({
    type: FETCH_OPEN_ORDER_FAILED,
    err,
  }),

  fetchOrderAction: (data) => ({
    type: FETCH_ORDER,
    params: {
      data,
    },
  }),
  fetchOrderActionSucceed: (data) => ({
    type: FETCH_ORDER_SUCCEED,
    params: {
      data,
    },
  }),
  fetchOrderActionFailed: (err) => ({
    type: FETCH_ORDER_FAILED,
    err,
  }),

  fetchOrderPaginateAction: (data, callback) => ({
    type: FETCH_ORDER_PAGINATE,
    params: {
      data,
    },
    callback,
  }),
  fetchOrderPaginateActionSucceed: (data) => ({
    type: FETCH_ORDER_PAGINATE_SUCCEED,
    params: {
      data,
    },
  }),
  fetchOrderPaginateActionFailed: (err) => ({
    type: FETCH_ORDER_PAGINATE_FAILED,
    err,
  }),

  cancelOrderAction: (data, callback, pageSize = consts.DEFAULT_PAGE_SIZE, isExchange = true) => ({
    type: CANCEL_ORDER,
    params: {
      data,
    },
    callback,
    pageSize,
    isExchange,
  }),
  cancelOrderActionSucceed: (data) => ({
    type: CANCEL_ORDER_SUCCEED,
    params: {
      data,
    },
  }),
  cancelOrderActionFailed: (err) => ({
    type: CANCEL_ORDER_FAILED,
    err,
  }),

  cancelAllOrderAction: (data, callback, pageSize = consts.DEFAULT_PAGE_SIZE, isExchange = true) => ({
    type: CANCEL_ALL_ORDER,
    params: {
      data,
    },
    callback,
    pageSize,
    isExchange,
  }),
  cancelAllOrderActionSucceed: (data) => ({
    type: CANCEL_ALL_ORDER_SUCCEED,
    data,
  }),
  cancelAllOrderActionFailed: (err) => ({
    type: CANCEL_ALL_ORDER_FAILED,
    err,
  }),

  fetchAllOrderAction: (data, callback) => ({
    type: FETCH_ALL_ORDER,
    params: {
      data,
    },
    callback,
  }),
  fetchAllOrderActionSucceed: (data) => ({
    type: FETCH_ALL_ORDER_SUCCEED,
    params: {
      data,
    },
  }),
  fetchAllOrderActionFailed: (err) => ({
    type: FETCH_ALL_ORDER_FAILED,
    err,
  }),

  fetchOrdersAction: (data, callback) => ({
    type: FETCH_ORDERS,
    params: {
      data,
    },
    callback,
  }),
  fetchOrdersActionSucceed: (data) => ({
    type: FETCH_ORDERS_SUCCEED,
    params: {
      data,
    },
  }),
  fetchOrdersActionFailed: (err) => ({
    type: FETCH_ORDERS_FAILED,
    err,
  }),

  fetchOpenOrdersPaginateAction: (data, callback) => ({
    type: FETCH_OPEN_ORDERS_PAGINATE,
    params: {
      data,
    },
    callback,
  }),
  fetchOpenOrdersPaginateActionSucceed: (data) => ({
    type: FETCH_OPEN_ORDERS_PAGINATE_SUCCEED,
    params: {
      data,
    },
  }),
  fetchOpenOrdersPaginateActionFailed: (err) => ({
    type: FETCH_OPEN_ORDERS_PAGINATE_FAILED,
    err,
  }),

  addOrderAction: (data, callback) => ({
    type: ADD_ORDER,
    params: {
      data,
    },
    callback,
  }),
  addOrderActionSucceed: (data) => ({
    type: ADD_ORDER_SUCCEED,
    params: {
      data,
    },
  }),
  addOrderActionFailed: (err) => ({
    type: ADD_ORDER_FAILED,
    err,
  }),
};
